var React = require('react');

function SplitRouting (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 0.857178L5.625 4.30105L12 10.8062L18.375 4.30105L15 0.857178H24V10.0409L20.625 6.59697L13.5 13.8674V23.1429H10.5V13.8674L3.375 6.59697L0 10.0409V0.857178H9Z","fill":"#FFEE55"}));
}

SplitRouting.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SplitRouting;

SplitRouting.default = SplitRouting;
